module.exports = "<div class=\"container\">\r\n\t<table>\r\n\t\t<tr>\r\n\t\t\t<td>\r\n\t\t\t\t<mat-spinner></mat-spinner>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t</table>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/mask/mask.component.html
// module id = ./src/app/shared/components/mask/mask.component.html
// module chunks = main